/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Campaign/Enums/CampaignChannel.php */
export const campaignChannel = {
	META: 'meta',
	CAREER_SITE: 'career_site',
} as const

/** @see backend/nexus/modules/Campaign/Enums/CampaignChannel.php */
export type CampaignChannel = (typeof campaignChannel)[keyof typeof campaignChannel]

export const campaignChannelMethods = {
	isBillable(value: CampaignChannel): boolean {
		const table: Record<CampaignChannel, boolean> = {
			meta: true,
			career_site: false,
		}
		return table[value]
	},
	isTogglableWhileLive(value: CampaignChannel): boolean {
		const table: Record<CampaignChannel, boolean> = {
			meta: false,
			career_site: true,
		}
		return table[value]
	},
} as const
